import { Navigation } from "../navigation";
import "./App.css";

export const App = () => {
  return <Navigation />;
};

export default App;
